import classnames from 'classnames';
import { Container } from '@stadionhq-v3/base-ui';
import RefereeAppointmentCard from '@components/molecules/referee-appointment-card';
import { RefereeAppointmentListingProps } from './refereeAppointmentListing.types';
import styles from './refereeAppointmentListing.module.scss';

/**
 * Referee Appointment Listing — a vertical stack of referee appointment cards.
 * The `.listing` wrapper is a full-width grey band; the inner Container
 * re-constrains the cards to the grid width.
 *
 * Storybook-isolation preview: fully mock-driven, no data fetching.
 */
const RefereeAppointmentListing = ({
  nativeProps = {},
  classNames = [],
  testId = 'referee-appointment-listing',
  appointments,
  footer,
}: RefereeAppointmentListingProps) => (
  <div
    {...nativeProps}
    data-testid={testId}
    className={classnames(styles.listing, classNames)}
  >
    <Container>
      <div className={styles.listing__items}>
        {appointments.map((appointment) => (
          <RefereeAppointmentCard
            // No stable id in this preview model; kick-off + teams uniquely
            // identifies a fixture.
            key={`${appointment.kickOffUtc}-${appointment.homeTeam.name}-${appointment.awayTeam.name}`}
            {...appointment}
          />
        ))}
      </div>

      {footer ? <div className={styles.listing__footer}>{footer}</div> : null}
    </Container>
  </div>
);

export default RefereeAppointmentListing;
